module.exports = __webpack_public_path__ + "static/media/image-2.f0c7306a.jpeg";